import { getCurrencySymbol } from "mt-components/localization";
import { Coupon, CouponType, Currency } from "../../graphql/operations";

export const getCurrencySymbolOrPercentage = ({
  type,
  currency,
}: Pick<Coupon, "type" | "currency">) =>
  type === CouponType.Percentage ? "%" : getCurrencySymbol(currency!);

export function formatCoupon(coupon: Coupon, currency?: Currency) {
  return `${
    coupon.type === CouponType.Fixed
      ? getCurrencySymbol(currency ?? coupon.currency)
      : ""
  }${coupon.amount}${coupon.type === CouponType.Percentage ? "%" : ""}`;
}

export const applyCoupon = (price: number, coupon: Coupon) => {
  const discountedPrice =
    coupon.type === CouponType.Percentage
      ? price - price * (coupon.amount / 100)
      : price - coupon.amount;

  return Math.max(0, discountedPrice);
};
